import url_ from "asset-data:assets/galleries/ua-2021-12-09/L1001030-color_8efb98b3b1__800.jpg";
export const url = url_;